import React, { useState, useEffect } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import styles from './Skills.module.css';
import CloseIcon from '@mui/icons-material/Close';
import { SkillsProps, HYGIENIST_TYPES } from 'utils/types';
import Api from 'api'
interface Skills {
  skills: SkillsProps[];
  type: number;
  province: string;
  apiSkills: SkillsProps[];
}

const Skills: React.FC<Skills> = ({ skills, type, province, apiSkills }) => {
  const [missingSkills, setMissingSkills] = useState<SkillsProps[]>([]);

  useEffect(() => {
    const fetchMissingSkills = async () => {
      const requiredSkillNames = ['TDX', 'PSIC', 'CPRC'];
      try {
        const requiredSkills = apiSkills.filter(skill => requiredSkillNames.includes(skill.name));
        const missing = requiredSkills.filter(requiredSkill => !skills.some(skill => skill.name === requiredSkill.name));
        setMissingSkills(missing);
      } catch (error) {
        console.error("Error fetching skills:", error);
      }
    };

    fetchMissingSkills();
  }, [skills, type, province]);

  return (
    <>
      <h4 className={styles.skillsTitle}>Training & Certifications received</h4>
      <div className={styles.skillsList}>
        {skills.map((skill, index) => (
          <div key={index} className={styles.skillItem}>
            <CheckCircleIcon className={styles.checkIcon} />
            {skill.label}
          </div>
        ))}
      </div>

      {type === HYGIENIST_TYPES.ASSISTANT && missingSkills.length > 0 && (
        <>
          <h4 className={styles.skillsTitle}>This assistant has indicated they are not skilled or qualified in:</h4>
          <div className={styles.skillsList}>
            {missingSkills.map((skill, index) => (
              <div key={index} className={styles.skillItem}>
                <CloseIcon className={styles.crossIcon} />
                {skill.label}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default Skills;